import React, { useMemo } from "react";
import PropTypes from "prop-types";
import Combobox from "@ls/react-combobox-grid";
import {
  useRatingMetricsQuery,
  useRatingModesQuery,
  useRatingOptionsQuery,
} from "state/ratings/hooks";
import { summaryTypeOptionsWithoutRelative } from "state/selections/Constants/SummaryType";
import { Grid, Cell } from "styled-css-grid";
import styled from "styled-components";
import RatingDefinition from "state/ratings/RatingDefinition";

const StyledCell = styled(Cell)`
  display: inline-flex;
  flex-flow: column;
  justify-content: flex-end;
`;
const columnDefs = [
  {
    headerName: "Rating",
    field: "id",
  },
  {
    headerName: "Provider",
    field: "provider",
    width: 90,
    suppressSizeToFit: true,
  },
];

const AnalyticsSelectorComplication = ({ setDefinition, definition }) => {
  const { isFetching, data } = useRatingOptionsQuery();
  const ratingModesQuery = useRatingModesQuery();
  const ratingMetricsQuery = useRatingMetricsQuery();
  const ratingOptions = data?.ratingOptions ?? null;
  const ratingOptionsByRatingId = data?.ratingOptionsByRatingId ?? null;

  const [
    onChangeRatingId,
    onChangeSummary,
    onChangeRatingMode,
    onChangeRatingMetric,
  ] = useMemo(() => {
    return [
      (ratingId) => {
        const rating = ratingId ? ratingOptionsByRatingId?.[ratingId] : null; //rating could be null because of 1) rating objects havent yet been fetched or user cleared the selection drop down and ratingId is null
        setDefinition(
          new RatingDefinition({
            ...definition,
            ratingId: ratingId,
            analytic: rating?.analytic,
          })
        );
      },
      (value) =>
        setDefinition(
          new RatingDefinition({
            ...definition,
            summary: value,
          })
        ),
      (value) =>
        setDefinition(
          new RatingDefinition({
            ...definition,
            ratingMode: value,
          })
        ),

      (value) =>
        setDefinition(
          new RatingDefinition({
            ...definition,
            ratingMetric: value,
          })
        ),
    ];
  }, [definition, ratingOptionsByRatingId, setDefinition]);

  return (
    <Grid columns={12} gap="4px">
      <Cell width={8}>
        <Combobox
          options={ratingOptions}
          columnDefs={columnDefs}
          onChange={onChangeRatingId}
          isLoading={isFetching}
          value={definition.ratingId}
          labelKey={"id"}
          valueKey={"id"}
          label="Rating:"
          variation={0}
          size={"S"}
          gridHeight={175}
        />
      </Cell>
      <StyledCell width={4}>
        <Combobox
          options={summaryTypeOptionsWithoutRelative}
          onChange={onChangeSummary}
          value={definition.summary}
          label="Acc/Bmk:"
          clearable={false}
          variation={0}
          size={"S"}
          gridHeight={125}
        />
      </StyledCell>
      <StyledCell width={3}>
        <Combobox
          options={ratingModesQuery.data}
          onChange={onChangeRatingMode}
          value={definition.ratingMode}
          label="Mode:"
          clearable={false}
          variation={0}
          size={"S"}
          gridHeight={125}
          enableOptionObjectAsValue
        />
      </StyledCell>
      <StyledCell width={3}>
        <Combobox
          options={ratingMetricsQuery.data}
          onChange={onChangeRatingMetric}
          value={definition.ratingMetric}
          label="Metric:"
          clearable={false}
          variation={0}
          size={"S"}
          gridHeight={125}
          enableOptionObjectAsValue
        />
      </StyledCell>
    </Grid>
  );
};

AnalyticsSelectorComplication.propTypes = {
  setDefinition: PropTypes.func.isRequired,
  definition: PropTypes.object.isRequired,
};

export default AnalyticsSelectorComplication;
